exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table[data-v-b585b3be] {\n}\n", ""]);

// exports
